import { ManagementApi } from '@/features/api/services/managementApi'
import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'
import { useIsSuperAdmin } from '@/features/superAdmin/useIsSuperAdmin'

export async function clubRegisteredGuard(to, from, next) {
  const authStore = useAuthStore()
  const isSuperAdmin = useIsSuperAdmin()

  const routeClubId = Array.isArray(to?.query?.activeClubId)
    ? to.query.activeClubId[0]
    : to?.query?.activeClubId
  const clubId = routeClubId || getActiveClubId()

  const redirectUrl = to.fullPath

  console.log('[clubRegisteredGuard] Checking club registration for clubId:', clubId, to, from)

  if (!clubId && !isSuperAdmin) {
    console.log('[clubRegisteredGuard] No clubId found in route')
    next(`/auth/club-selector?redirectUrl=${redirectUrl}`)
    return
  }

  const clubs = authStore?.myDetails?.myTenants || []

  if (clubs.length === 0) {
    console.log('[clubRegisteredGuard] No clubs found on myTenants')
  }

  const club = clubs.find(club => club.tenantId === clubId)

  if (!club) {
    if (isSuperAdmin) {
      console.log('[clubRegisteredGuard] Super admin, no club found')
      console.log('[clubRegisteredGuard] we need to check that this club is waiting for finalize')

      const tenant = await ManagementApi.tenantGetDetails(clubId)

      console.log('[clubRegisteredGuard] tenant', tenant)

      if (!tenant) {
        console.log('[clubRegisteredGuard] tenant not found')
        next()
        return
      }

      if (!tenant?.isRegisteredFinalized) {
        console.log('[clubRegisteredGuard] Club is waiting for registration')
        next(`/club-register?clubId=${clubId}`)
        return
      }

      next()
      return
    }

    console.log('[clubRegisteredGuard] Club not found')
    next(`/auth/club-selector?redirectUrl=${redirectUrl}`)
    return
  }

  if (!club.isRegisteredFinalized) {
    console.log('[clubRegisteredGuard] Club not registered completely')

    next(`/club-register?clubId=${clubId}`)
    return
  }

  console.log('[clubRegisteredGuard] Club registered')

  next()
}
